import { PRICE_STEPS, bodyTypes, countBy, fuels, gbp, makeOfModel, makes, modelOptions, transmissions } from "@/lib/inventory";
import { SelectField } from "@/components/site/SelectField";

const priceOptions = PRICE_STEPS.map((p) => ({ value: String(p), label: gbp(p) }));
const minOptions = [1000, ...PRICE_STEPS].map((p) => ({ value: String(p), label: gbp(p) }));

const ChipGroup = ({ title, options, field, keyName, filters, toggle, prefix }) => (
  <fieldset>
    <legend className="field-label mb-3">{title}</legend>
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          key={o}
          type="button"
          className="chip"
          aria-pressed={filters[keyName].includes(o)}
          onClick={() => toggle(keyName, o)}
          data-testid={`${prefix}-${keyName}-${o.toLowerCase().replace(/\s+/g, "-")}-chip`}
        >
          {o} <span className="text-xs opacity-70">({countBy(field, o)})</span>
        </button>
      ))}
    </div>
  </fieldset>
);

export const FilterPanel = ({ filters, update, toggle, clear, activeCount, prefix }) => (
  <div className="grid gap-7" data-testid={`${prefix}-filter-panel`}>
    <div className="flex items-center justify-between">
      <h2 className="font-display text-lg font-extrabold">Filter cars</h2>
      {activeCount > 0 && (
        <button type="button" onClick={clear} className="link-underline text-sm font-semibold text-brand" data-testid={`${prefix}-clear-filters-button`}>
          Clear all
        </button>
      )}
    </div>
    <SelectField
      id={`${prefix}-make`}
      label="Make"
      value={filters.make}
      onChange={(make) => update({ make })}
      options={makes.map((m) => ({ value: m, label: `${m} (${countBy("make", m)})` }))}
      placeholder="Any make"
      testId={`${prefix}-make-select`}
    />
    <SelectField
      id={`${prefix}-model`}
      label="Model"
      value={filters.model}
      onChange={(model) => update(model && !filters.make ? { model, make: makeOfModel(model) } : { model })}
      options={modelOptions(filters.make)}
      placeholder="Any model"
      testId={`${prefix}-model-select`}
    />
    <div className="grid grid-cols-2 gap-3">
      <SelectField
        id={`${prefix}-min-price`}
        label="Min price"
        value={filters.minPrice ? String(filters.minPrice) : ""}
        onChange={(v) => update({ minPrice: Number(v) || 0 })}
        options={minOptions}
        placeholder="No min"
        testId={`${prefix}-min-price-select`}
      />
      <SelectField
        id={`${prefix}-max-price`}
        label="Max price"
        value={filters.maxPrice ? String(filters.maxPrice) : ""}
        onChange={(v) => update({ maxPrice: Number(v) || 0 })}
        options={priceOptions}
        placeholder="No max"
        testId={`${prefix}-max-price-select`}
      />
    </div>
    <ChipGroup title="Fuel type" options={fuels} field="fuel" keyName="fuel" filters={filters} toggle={toggle} prefix={prefix} />
    <ChipGroup title="Gearbox" options={transmissions} field="transmission" keyName="transmission" filters={filters} toggle={toggle} prefix={prefix} />
    <ChipGroup title="Body type" options={bodyTypes} field="bodyType" keyName="body" filters={filters} toggle={toggle} prefix={prefix} />
  </div>
);
